
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { requiredValidationRule } from '@/helpers/validationRules';
import { fetchGetLookupSuburb } from '@/helpers/fetchers';
import { ISelectSuburb, CustomSelectSuburb } from '@/models/jbAdvanced';
import { getSuburbItem } from '@/helpers/booking';
import _debounce from 'lodash/debounce';
import NoDataSelectItem from '@/components/selectItems/NoDataSelectItem.vue';
import CommonSelectItem from '@/components/selectItems/CommonSelectItem.vue';

@Component({
  components: {
    NoDataSelectItem,
    CommonSelectItem,
  },
})
export default class SuburbAutocompleteField extends Vue {
  @Prop(Object) public value: CustomSelectSuburb;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public debounceFetchWrapper = _debounce(this.fetchWrapper, 150);
  public search = '';
  public items: CustomSelectSuburb[] = [];
  public isFetching = false;
  public isComponentJustCreated = true; // TODO toggle first search when pass the value
  public isStateAndPostcodeShow = false;

  get fieldValue() {
    // console.debug('get fieldValue');
    const suburbItem = this.value;
    return suburbItem?.id;
  }

  set fieldValue(newSuburbId: string) {
    // console.debug('set fieldValue', newSuburbId);
    const suburbItem = this.items.find(item => item.id === newSuburbId);
    this.$emit('input', suburbItem);
  }

  @Watch('value', { immediate: true })
  private watchValue(suburbItem: CustomSelectSuburb) {
    // console.debug('watchValue', suburbItem);
    if (!suburbItem || !suburbItem.name) {
      return;
    }
    if (this.search === suburbItem.name) {
      this.isStateAndPostcodeShow = true;
    }
    if (!this.items.find(item => item.id === suburbItem.id)) {
      this.items = [suburbItem, ...this.items]; // TODO cancel
    }
  }

  public fetchWrapper(): Promise<void> {
    const search = this.search;
    this.isFetching = true;
    return fetchGetLookupSuburb(search) // TODO promised debounce and cancel
      .then((items: ISelectSuburb[]) => {
        if (search !== this.search) {
          return;
        }
        this.items = items.map(item => {
          return getSuburbItem(item.name, item.postcode, item.state);
        });
      })
      .finally(() => {
        this.isFetching = false;
      });
  }

  public getSearchString(search?: string | null) {
    return (search && search.trim()) || '';
  }

  @Watch('search')
  private watchSearch(newSearch?: string | null, oldSearch?: string | null) {
    this.isStateAndPostcodeShow = false;
    // console.debug('newSearch', newSearch, this.value?.name);
    // console.debug('oldSearch', oldSearch, this.value?.name);
    if (newSearch === null && this.fieldValue) {
      this.fieldValue = '';
      return;
    }
    newSearch = this.getSearchString(newSearch);
    oldSearch = this.getSearchString(oldSearch);
    if (newSearch === this.value?.name) {
      this.isStateAndPostcodeShow = true;
    }
    if (newSearch.length >= 3) {
      if (newSearch.toUpperCase() !== oldSearch.toUpperCase()) {
        this.debounceFetchWrapper();
      }
    } else {
      this.items = []; // TODO cancel
    }
  }

  public fieldValidationRules = [requiredValidationRule];
}
